import React from 'react'
import Hero from '../components/Hero'
import About from '../components/About'
import Team from '../components/Team'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import { useTheme } from '../components/ThemeContext';
import Contact from '../components/Contact'
import Features from '../components/Features'
function Home() {
  const { isDarkMode } = useTheme();
  return (
    <section className={isDarkMode ? 'dark' : ''}>
    <div id='/home'
    className="bg-cyan-500  dark:bg-zinc-900 bg-opacity-10 flex flex-col">
        <Navbar />
        <Hero  />
        <About />
        <Features />
        <Team />
        <Contact />
        <Footer />

    </div>

    </section>
  )
}

export default Home